<template>
  <div>
    <Row style="width: 100%;margin-top:110px ">
      <Col span="24">
            <img :src="img" width="100%" height="100%" style="vertical-align: bottom;">
      </Col>
    </Row>
    

<Row >
    <Col style="float: left;width: 25%;position:relative;">
        <img :src="img2" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
         车险智能风控
        </div>
    </Col>
    <Col style="float: left;width: 25%;position:relative;">
        <img :src="img3" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        二手车估值
        </div>
    </Col>
     <Col style="float: left;width: 25%;position:relative;">
        <img :src="img4" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        汽车后市场 
        </div>
    </Col>
     <Col style="float: left;width: 25%;position:relative;">
        <img :src="img5" width="100%" style="vertical-align:bottom;height: 110px;">
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        API数据服务
        </div>
    </Col>
     
  </Row>


    <Row style="text-align: center;color: #000;font-size: 23px;line-height: 40px;padding: 1% 0;margin-top: 80px;">
        了解产品
    </Row>


    <Row  style="display: flex;justify-content: center;">
      <Col span="4" style="margin-top:100px">
          <img :src="img6" width="50%">
      </Col>
      
      <Col span="12" style="line-height: 30px;margin-left:100px;margin-top:50px
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 55%;
                            float: left;
                            margin-left: 8%;
                            padding: 4% 4%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><span >车险智能风控</span>          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;text-align:left"><span >泽达数据的“泽达车险智能风控系统"是基于自主开发的故据系统嵌入保险公司理赔系统提供服务，实现车险核损的反欺诈和反渗漏够查，通过有效降低保险公司传统定损系统造成的骗保损失收取服务费用:在保险公司理赔环节中，主要服务环节为核损及核价，通过数据规则及逻辑规则从定损单中挖掘欺诈信息，为核损提供风险提示，提升核损效率;对车险核损岗的工作进行规范，便于提高案件处理效率以及风险管控能力。</span>
            </Row>
      </Col>
      
      
    </Row>



    <Row style="display: flex;justify-content: center;margin-top:100px;">
     
      
      <Col span="12" style="line-height: 30px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 55%;
                            float: left;
                            padding: 4% 4%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><span >二手车估值</span>          </Row>
            <Row style="font-size:18px;text-indent:2em;text-align:left"><span >在二手车估值方面，公司推出了套新的更为全面、 更为精确、更为实用的二手车评估方法，以期帮助车主、评估师、车商们对车辆进行精准的评估，从而推动二手车市场的健康快速发展。综合参考当前同款全新车辆市场价格、被评估车辆的总体技术状况，同时分析整个汽车行业技术进步带来的影响，引入科技创新参数衡量被评估车辆的科技化价值，最终消除人为主观因素带来的评估偏差，从而得到精确的评估结果。</span>
            </Row>
      </Col>
      
       <Col span="4" style="margin-left:100px;margin-top:50px">
          <img :src="img6" width="50%">
      </Col>
    </Row>


    <Row style="display: flex;justify-content: center;margin-top:100px">

      <Col span="4" style="margin-left:100px;margin-top:50px">
          <img :src="img6" width="50%">
      </Col>
      
      <Col span="12" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 55%;
                            float: left;
                            padding: 4% 4%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><span >汽车后市场</span>          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;text-align:left"><span >汽车后市场存在汽车零配件名称不统一、种类繁多，客户及供应商无法精准描述，找到相匹配的零配件极其困难的问题，中科泽达拥有20万+的全车件名称匹对，可以进行智能搜索，智能匹配，解决汽配件无法精准匹配的问题。</span>
            </Row>
      </Col>
      
      
    </Row>


    <Row style="display: flex;justify-content: center;margin-top:100px;">
     
      
      <Col span="12" style="line-height: 30px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 55%;
                            float: left;
                            padding: 4% 4%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><span >API数据服务</span>          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;text-align:left"><span >API数据服务于汽车业务，独有汽车底层精准数据库，数据更新速度快、覆盖类型全提供车辆精准定型定款、汽车零配件查询、二手车快速估值等数据服务。</span>
            </Row>
      </Col>
      
      <Col span="4" style="margin-left:100px;margin-top:50px">
          <img :src="img6" width="50%">
      </Col>
    </Row>






     <Row style="text-align: center;color: #000;font-size: 23px;line-height: 40px;padding: 1% 0;margin-top: 80px;">
        基础数据储备库
    </Row>


     <Row style="margin-top:40px;margin-left:250px">
     
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:50px
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img7" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >1.6亿</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >车辆基本配置信息</span>
            </Row>
      </Col>
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:50px
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img8" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >102万</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >车辆公示信息</span>
            </Row>
      </Col>
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:50px
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img9" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >5500万</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >OEM零件数量</span>
            </Row>
      </Col>

      
    </Row>
    </br>

    <Row style="margin-top:80px;margin-left:250px">
     
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:-4%;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img10" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >500万</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >车辆图片信息</span>
            </Row>
      </Col>
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:-4%;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img11" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >8.9万</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >乘用车配置信息</span>
            </Row>
      </Col>
      <Col span="6" style="line-height: 30px;margin-left:100px;margin-top:-4%;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 25%;
                            float: left;
                            margin-left: 2%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px"><img :src="img12" width="20%">          </Row>
            <Row style="margin-top: 20px;font-size:18px;text-indent:2em;"><span >45+</span> </Row>
            <Row style="margin-top: 20px;font-size:14px;text-indent:2em;"><span >车辆品牌</span>
            </Row>
      </Col>
    </Row>


    <Row style="display: flex;justify-content: center;margin-top:100px;">
     
      <Col span="8" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 40%;
                            float: left;
                            margin-left: -1%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;"><Row style="color: #6a4fe1;letter-spacing: 3px;font-size:22px">      </Row>
            <Row style="margin-top: 20px;padding: 2% 2%;font-size:18px;text-indent:2em;text-align:left;"><span >数据涵盖99%市面销售车辆及98%比对正确率，数据层级明确并且数据提供商众多，通过循坏式的数据迭代及计算机智能学习完善全品牌数据库。</span> </Row>
          
      </Col>
      <Col span="8" style="line-height: 30px;margin-left:100px;
                            <!-- text-indent: 38px; -->
                            font-size: 18px;
                            width: 40%;
                            float: left;
                            margin-left: 4%;
                            padding: 2% 2%;
                            box-shadow: 0px 0px 10px 5px #dcd9ed;
                            border: 1px solid #efefef;">
            <Row style="margin-top: 20px;padding: 2% 2%;font-size:18px;text-indent:2em;text-align:left;"><span >经过10年以上的汽车大数据产业数据、服务与经验积淀，泽达数据已自主开发出一套完善的数据库系统，并实时更新升级，已具备行业领先优势。</span> </Row>
            
      </Col>
    </Row>

    <Row style="margin-top:110px;">
   

    <!--<Col style="float: left;width: 50%;position:relative;">
        <router-link to="/#">
        <div  style="vertical-align:bottom;height: 110px;background: linear-gradient(to top right, #426bff, #20a8ff);"></div>
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        申请合作
        </div>
         </router-link>
    </Col>
    <Col style="float: left;width: 50%;position:relative;">
        <div  style="vertical-align:bottom;height: 110px;background: linear-gradient(to top right, #fb7497, #fca86c);"></div>
        <div style="position: absolute; width: 100%; height: 100%; left: 0px; top: 0px;line-height: 100px;font-size: 24px;color: white;">
        观看视频
        </div>
    </Col>-->
    
     
  </Row>

    

   

     
  </div>
 
</template>
<script>
export default {
  data() {
    return {
      columns1: [
                    {
                        title: 'Title',
                        key: 'title'
                    },
                    {
                        title: 'View',
                        key: 'view'
                    },
                    {
                        title: 'Time',
                        key: 'time'
                    }
                ],
                data2: [
                    {
                        title: 'John Brown',
                        view: 18,
                        time: 'New York No. 1 Lake Park',
                    },
                    {
                        title: 'John Brown',
                        view: 18,
                        time: 'New York No. 1 Lake Park',
                    },
                    {
                        title: 'John Brown',
                        view: 18,
                        time: 'New York No. 1 Lake Park',
                    },
                    {
                        title: 'John Brown',
                        view: 18,
                        time: 'New York No. 1 Lake Park',
                    },
                    {
                        title: 'John Brown',
                        view: 18,
                        time: 'New York No. 1 Lake Park',
                    },
                ],
                
      info:23923,
      bid:115486,
      money:16745305.75,
      noticeList:[],
      data1: [],
      // data2: [],
      data3: [],
      data4: [],
      img: "../../../../static/officeImg/carxian/banner.png",
      img2:"../../../../static/officeImg/gas/1-h200.png",
      img3:"../../../../static/officeImg/gas/2-200.png",
      img4:"../../../../static/officeImg/gas/3-200.png",
      img5:"../../../../static/officeImg/gas/4-200.png",
      img6:"../../../../static/officeImg/carxian/010.png",
      img7:"../../../../static/officeImg/carxian/1.png",
      img8:"../../../../static/officeImg/carxian/2.png",
      img9:"../../../../static/officeImg/carxian/3.png",
      img10:"../../../../static/officeImg/carxian/4.png",  // img3: "../../../static/1.jpg",
      img11: "../../../static/officeImg/carxian/5.png",
      img12: "../../../static/officeImg/carxian/6.png",
      // img27:"../../../../static/officeImg/gas/fenghui3.png",  // img3: "../../../static/1.jpg",
      // img28: "../../../static/officeImg/gas/94.png",
    
    
    };
  },
   filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
  },
  mounted() {
    this.loadData();
    var swiper1 = new Swiper('.swiper1', {
            pagination: '.swiper-box1 .swiper-pagination',
            slidesPerView: 3,
            paginationClickable: true,
            spaceBetween: 30,
            nextButton: '.swiper-box1 .swiper-button-next',
            prevButton: '.swiper-box1 .swiper-button-prev',
           // loop: true,
            //autoplay: 2500,
            autoplayDisableOnInteraction: false,
        });
    //千位分割符
     this.money= this.toThousands(this.money,2);
  },
  methods: {
    loadData: function() {
    },
    Goto: function(type,id){
         switch (type) {
          case 'C01':
            {
              this.$router.push({ name: 'detail', query: { detailId: id}})
            }
            break;
          case 'C02':
            {
                this.$router.push({ name: 'detail2', query: { detailId: id}})
            }
            break;
          case 'C03':
            {
                this.$router.push({ name: 'detail1', query: { detailId: id}})
            }
            break;
         case 'C04':
            {
                this.$router.push({ name: 'detail3', query: { detailId: id}})
            }
            break;
            default:
            break;
        }
    },
    more: function() {
      this.$router.push({ path: "/item" });
    },
     //千位分割符
      toThousands: function(num,n, separator) {
     let parts;
     num = num + "";
     // 判断是否为数字
     if (!isNaN(parseFloat(num)) && isFinite(num)) {
    let nx;
         nx=Math.pow(10,n);

         num = (Math.round(num* nx) / nx).toFixed(n);


         parts = num.split('.');
         parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));

         return parts.join('.');
     }
     return NaN;
}
  }
};
</script>
<style scoped>
.img-group{
  position: relative;  
  display: inline-block;
}
.arTitle {
    padding-left: 9%;
    color: rgb(14, 96, 228);
    font-size: 22px;
    font-weight: 700;
    padding-bottom: 28px;
}
.img-tip{
  position: absolute;
  bottom: 0;  
  background: #333;  
  color: #fff;  
  opacity: 0.6;  
  display: none;
}
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal{
  position:relative;
  left:180px;
  margin-top:40px;
}
.FontLocal{
  margin-top:60px;
}
.title {
    text-align: center;
    color: rgb(0, 0, 0);
    font-size: 23px;
    line-height: 40px;
    padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard{
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  
}
.cardTitle{
  text-align: left;
  font-weight:540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian{
 font-size: 20px;
}
.shuxian{
  display:inline-block;
  width:4px;
  height: 22px;
  background: orange;
}
.icon-gengduo{
  color: orange;
}
.gengduo{
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian{
  font-size: 15px;
  font-weight:540;
  color:#787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/carData/carData.vue